export const menus = [
  { id: 1, title: 'About', link: '/about', url: '' },
  { id: 2, title: 'My Skills', link: '/my-skill', url: '' },
  { id: 3, title: 'Work', link: '/my-works', url: '' },
  { id: 4, title: 'Gallery', link: '/gallery', url: '' },
  { id: 5, title: 'Contact', link: '/contact', url: '' },
];
